import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {TelemetryOPEEnum} from "./TelemetryOPEEnum";
import {BucketUnitEnum} from "../../enums/dashboard/ChartsEnum";

class O {
  chartData!: any[];
  warningMessage!: string | null;
}

export class PuntoMisure {
  time!: number;
  mappaValori?: any[] = [];
}

/**
 * O Inner Class
 */
class I {
  dateFrom!: number;
  dateTo!: number;
  bucketUnits!: BucketUnitEnum;
  bucketValue!: number;
  timeChartRealMetrics: TimeChartRealMetricDTO[];
  timeChartBooleanMetrics: TimeChartBooleanMetricDTO[];

  constructor() {
    this.dateFrom = 0;
    this.dateTo = 0;
    this.timeChartRealMetrics = [];
    this.timeChartBooleanMetrics = [];
  }

}

export class TimeChartRealMetricDTO {
  deviceId!: number;
  metricInstanceId!: number;
  metricAlias?: string; // deviceId_metricId_pos
  functionType?: string;
  decimalDigits?: number | null;
  isBoolean: boolean = false;
}

export class TimeChartBooleanMetricDTO {
  deviceId!: number;
  metricInstanceId!: number;
  metricAlias?: string; // deviceId_metricId_pos
  isBoolean: boolean = true;
}


export class GetTimeChartMetricsCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(TelemetryOPEEnum.GetTimeChartMetrics);
    this.i = new I();
    this.o = new O();
  }
}
